<script>
import {useRoute} from "vue-router";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import {ref} from "vue";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";

export default {
  name: "SearchBy",
  components: {LoadingPage},

  setup() {


    let text = useRoute().params.text
    let all_prod = []
    let search_prod = ref([])

    let loading = ref(false)


    function all_products() {

      loading.value = true
      FreeWorld.Heisenberg({}, 'products' , true).then((res) => {

        loading.value = false
        all_prod = res.data
        filteredProducts()

      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, all_products)
      })

    }
    all_products()


    function filteredProducts() {

      all_prod.forEach((category) => {
        category.subcategory.forEach((subcategory) => {
          subcategory.products.forEach((product) => {
            if (product.name.includes(text) || product.brand.includes(text)) {
              search_prod.value.push(product);
            }
          });
        });
      });

    }


    return {

      search_prod,
      loading,

    }
  }
}
</script>


<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div id="main" :class="loading ? 'activeClass':'' " class="bg-main">


    <div class="div-top-arrow shadow-custom bg-white">
      <div class="d-flex justify-content-between align-items-center">
        <p class="font-color font-4 font-bold">نتایج جستجو</p>
        <img onclick="window.history.back()" class="svg-arrow" src="../assets/img/arrow.svg" alt="">
      </div>
    </div>
    <br>
    <br>
    <br>

    <div v-if="search_prod.length !== 0" class="p-body mt-3">

      <router-link :to="{name:'DetailsProducts' , params:{pid:item.id}}" v-for="item in search_prod" :key="item.id" class="animate__animated animate__fadeInRight text-decoration-none bg-white mb-3 shadow-custom p-2 rounded-4 d-flex justify-content-between">
        <div class="w-60 ml-3 d-flex flex-column justify-content-around">
          <div class="overflow-hidden">
            <p class="font-bold font-5" :class="{'txtoverflow': item.name.length > 30}">{{ item.name }}</p>
          </div>

          <div class="overflow-hidden">
            <p class="font-5 my-2" :class="{'txtoverflow': item.brand.length > 20}">از برند {{ item.brand }}</p>
          </div>
          <div class="d-flex align-items-center">
            <p v-if="item.price !== null || item.shops !== 0" class="font-5 d-flex font-color font-bold mr-3">
              <span class="">{{ item.price.toLocaleString() }}</span>
              <span class="mr-1">تومان</span>
            </p>

            <p v-else class="font-4 d-flex font-color-red font-bold mr-3">ناموجود</p>
          </div>

          <div class="div_hr my-2"></div>

          <div class="d-flex align-items-center justify-content-between">

            <div class="d-flex align-items-center">
              <img class="icon_shop ml-2" src="../assets/img/store_color.svg" alt="">
              <p class="font-5">{{ item.shops }} فروشگاه</p>
            </div>

            <button class="bg-color-light py-1 px-2 font-5 rounded-pill shadow-custom">مشاهده جزییات</button>
          </div>

        </div>

        <div class="img_prod rounded-3 animated-background">
          <img class="w-100 h-100 rounded-3" :src="item.pic" alt="">
        </div>
      </router-link>

    </div>

    <div v-else style="height: 55vh" class="d-flex justify-content-center w-100 animate__animated animate__fadeIn">
      <div class="d-flex flex-column align-items-center justify-content-end">
        <img src="../assets/img/product-not-found.png" class="mb-3 w-50" alt="">
        <p class="font-3 font-bold">متاسفانه محصولی با این نام وجود ندارد!</p>
      </div>
    </div>


  </div>

</template>


<style scoped>

@media (min-width: 900px) {
  .img_prod {
    width: 26% !important;
    height: 12rem !important;
  }
}
.img_prod {
  width: 40%;
  height: 11.3rem;
}

.div_hr {
  width: 100%;
  height: 1px;
  border: rgba(43, 48, 53, 0.47) dashed 1px;
}

.icon_shop {
  width: 15px;
}

</style>